import { appList } from "@/api/common/index";
const app = {
  state: {
    theme: '',
    applications: [],
  },
  mutations: {
    SET_THEME(state, theme) {
      state.theme = theme;
      document.title = '睿客网 - ' + theme
    },
    setApps(state, payload) {
      state.applications = payload
    }
  },
  actions: {
    getApps({commit}) {
      appList()
        .then(res => {
          if (res.status_code === 200) {
            commit("setApps", res.entity);
          } else {
            this.$message({
              type: "error",
              message: res.message
            });
          }
        })
        .catch(err => {
          this.$message({
            type: "error",
            message: err
          });
        });
    },
  }
}

export default app